import styled from '@emotion/styled';

export const Title = styled.div`
	font-weight: bold;
	margin-bottom: 12px;
`;
